<ng-container *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'">
  {{taskSelector?.Code}}
  <app-source-code-view [code]="taskSelector.Code" [sourceCode]="taskSelector.SourceCode"></app-source-code-view>
  <div *ngIf="taskSelector.Specs?.length" class="h6">{{t('Specs')}}</div>
  <app-spec-lines-view [specs]="taskSelector.Specs" [inline]="false"></app-spec-lines-view>
  <div class="cell-action" ngbDropdown #tsEditDropdown="ngbDropdown" contenteditable="false" container="body" [autoClose]="'outside'">
    <button class="btn btn-outline-default btn-sm dropdown-toggle" tabindex="-1" type="button" ngbDropdownToggle>±</button>
    <div class="dropdown-menu position-absolute" ngbDropdownMenu role="menu">
      <form class="px-4 py-3">
        <div class="form-group">
          <label class="h6" for="tsCode-{{taskSelector.Id}}">{{t('Code')}}</label>
          <input type="text" class="form-control form-control-plaintext" id="tsCode-{{taskSelector.Id}}" [value]="taskSelector?.Code">
        </div>
        <div class="form-group">
          <label class="h6" for="validCondition">{{t('Valid Condition')}}</label>
          <app-expression-formula-view id="validCondition" [expression]="taskSelector.ValidCondition"></app-expression-formula-view>
        </div>
      </form>
      <a class="dropdown-item border-top" (click)="editTaskSelector(); tsEditDropdown.close()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        {{t('Edit task selector')}}
      </a>
      <app-copy-paste-menu-item [allowCopyAll]="masterOperation.TaskSelectors.length > 1" [readonly]="readonly"
                                    (onCopy)="copy(); tsEditDropdown.close()"
                                    (onCopyAll)="copy(true); tsEditDropdown.close()"
                                    (onPaste)="paste(masterOperation); tsEditDropdown.close()"
                                    (onClipboardPaste)="paste(masterOperation, true); tsEditDropdown.close()"></app-copy-paste-menu-item>
      <a class="dropdown-item" (click)="integratedMasterService.addMasterUseInstructionAfter(masterOperation, null, taskSelector.Id); changed.emit(); tsEditDropdown.close()">
        {{t('Add resource usage')}}
      </a>
      <a class="dropdown-item" (click)="integratedMasterService.addMasterInputInstructionAfter(masterOperation, masterOperation.getLastInputInstruction(), taskSelector.Id); changed.emit(); tsEditDropdown.close()">
        {{t('Add item usage')}}
      </a>
      <a class="dropdown-item" (click)="integratedMasterService.addMasterOutputInstructionAfter(masterOperation, masterOperation.getLastOutputInstruction(), taskSelector.Id); changed.emit(); tsEditDropdown.close()">
        {{t('Add process result')}}
      </a>
    </div>
  </div>
</ng-container>
